import React, { useState, Fragment } from "react";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";
import { icons } from "../../../Common/Components/ClassIcons";

function Create() {
  const initalState = {
    loading: false,
  };
  const [state, setstate] = useState(initalState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };
  return (
    <CommonFrom
      form={input}
      loading={state.loading}
      header="ایحاد امکانات"
      textbtn="لیست امکانات"
      linkbtn="/Admin/Option/List"
      btnName="ایجاد امکانات"
      submit={Handler}
      initialeState={{ checked: true, status: "active" }}
    />
  );
}

export default Create;
export const input = [
  {
    label: "عنوان",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "name",
    value: "",
    type: "text",
  },
  {
    label: "وضعیت",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "status",
    value: [],
    items: [
      { label: "فعال", value: "active", checked: true },
      { label: "غیر فعال", value: "deactive" },
    ],
    input: "switch",
  },
  {
    label: "",
    size: "col-md-6",
    name: "icon",
    value: null,
    input: "icons",
  },
];
